import { render } from "./Speyecare.vue?vue&type=template&id=5dbdb13c"
import script from "./Speyecare.vue?vue&type=script&lang=js"
export * from "./Speyecare.vue?vue&type=script&lang=js"

import "./Speyecare.vue?vue&type=style&index=0&id=5dbdb13c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__